import { Header, headerConfigDefaults } from '@qga/components';
import { useSelector } from 'react-redux';
import { getAuthIsAuthenticating, getAuthentication, getIsSSOLoginScreenVisible } from 'store/authentication/selectors';
import { getQffAuth } from 'lib/qffAuth';
import { createEventCreator } from 'lib/gaTracking/ga';
import useSplitTreatment from 'hooks/useSplitTreatment';
import { SplitIO } from 'types';
import useOAuth from 'hooks/useOAuth';
import { FC } from 'react';
import { GA } from 'types';
import sendGAEvent from 'utils/sendGAEvent';

const handleInteraction = createEventCreator((info: { type: string; value: string }) => ({ action: info.value, category: info.type }));

const GlobalHeader: FC = () => {
  const { isReady, split } = useSplitTreatment(SplitIO.Split.SELF_SERVICE_OAUTH, SplitIO.Treatment.ON);

  const { ssoUser } = useSelector(getAuthentication);
  const isAuthenticating = useSelector(getAuthIsAuthenticating);
  const isSSOLoginScreenVisible = useSelector(getIsSSOLoginScreenVisible);

  const authAPI = getQffAuth();

  const { login, logout } = useOAuth();

  if (!isReady || isAuthenticating) {
    return null;
  }

  const handleClickLogin = () => {
    if (split) {
      login();
      return;
    }

    if (!isSSOLoginScreenVisible) {
      authAPI?.showLoginModal();
    }
  };

  const handleClickLogout = () => {
    if (split) {
      logout();
      // GA4
      sendGAEvent({
        type: GA.EventType.LOGOUT,
        method: GA.AuthMethod.OAUTH,
      });
      return;
    }

    authAPI?.logout();
  };

  return (
    <Header
      {...headerConfigDefaults}
      qffAuthData={ssoUser}
      onClickLogin={handleClickLogin}
      onClickLogout={handleClickLogout}
      onInteraction={handleInteraction}
    />
  );
};

export default GlobalHeader;
